import { Avatar, Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconRejected from "../../assets/images/contract/x-circle.svg";
import { RiResetLeftFill } from "react-icons/ri";
import iconCheckRed from "../../assets/images/iconCheckRed.png";
import iconEdit from "../../assets/images/product/edit.svg";
import { formatNumber, formatPriceUS } from "../../utils/utils";
import { formatDateDb, formatMonthDb } from "../../utils/tools";

export const formatTableValue = (
  value,
  key,
  submit,
  id,
  revert,
  handleNavigateCaculatePage,
  statusEdit,
) => {
  switch (key) {
    case "startTime":
      const timestamp = value;

      const date = new Date(timestamp);

      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      return <Text>{formattedDate}</Text>;
    case "isBrokerDebtCertificate":
      let contentBrokerDebtCertificate;
      if (!value) {
        contentBrokerDebtCertificate = (
          <Box
            // color={"var(--color-option-employee-hover)"}
            // textDecoration={"underline"}
            lineHeight={"28px"}
            cursor={"pointer"}
            fontWeight={"500"}
            onClick={() =>
              statusEdit ? null : submit("CHECKED", id, value, key)
            }
          >
            <Flex gap={"8px"} justifyContent={"start"}>
              <Text w={"52px"}>Chưa có</Text>
              {statusEdit ? "" : <Image src={iconEdit} />}
            </Flex>
          </Box>
        );
      } else {
        contentBrokerDebtCertificate = (
          <Box
            // color={"var(--color-option-employee-hover)"}
            // textDecoration={"underline"}
            lineHeight={"28px"}
            cursor={"pointer"}
            fontWeight={"500"}
            onClick={() =>
              statusEdit ? null : submit("CHECKED", id, value, key)
            }
          >
            <Flex gap={"8px"} justifyContent={"start"}>
              <Text w={"52px"}>Đã có</Text>
              {statusEdit ? "" : <Image src={iconEdit} />}
            </Flex>
          </Box>
        );
      }

      return (
        <Flex gap={"8px"} w={"100%"}>
          {contentBrokerDebtCertificate}
        </Flex>
      );
    case "isBrokerDebtCertificateData":
      let contentBrokerDebtCertificateData;
      if (!value) {
        contentBrokerDebtCertificateData = <Text>Chưa có</Text>;
      } else {
        contentBrokerDebtCertificateData = <Text>Đã có</Text>;
      }

      return (
        <Flex gap={"8px"} w={"100%"} justifyContent={"center"}>
          {contentBrokerDebtCertificateData}
        </Flex>
      );
    case "amountHeld":
      return (
        <Box
          // color={"var(--color-option-employee-hover)"}
          // textDecoration={"underline"}
          lineHeight={"28px"}
          cursor={"pointer"}
          fontWeight={"500"}
          onClick={() => (statusEdit ? null : submit("NUMBER", id, value, key))}
        >
          <Flex gap={"8px"} justifyContent={"right"}>
            <Text>{value ? `${formatNumber(value)} VNĐ` : "0 VNĐ"}</Text>
            {statusEdit ? "" : <Image src={iconEdit} />}
          </Flex>
        </Box>
      );
    case "workingDays":
      return (
        <Box
          // color={"var(--color-option-employee-hover)"}
          // textDecoration={"underline"}
          lineHeight={"28px"}
          cursor={"pointer"}
          fontWeight={"500"}
          onClick={() => (statusEdit ? null : submit("NUMBER", id, value, key))}
        >
          <Flex gap={"8px"} justifyContent={"start"}>
            <Text w={"52px"}>{value}</Text>
            {statusEdit ? "" : <Image src={iconEdit} />}
          </Flex>
        </Box>
      );

    case "contact":
      const infos = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {infos?.length &&
            infos?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    case "participantList": {
      const participantList = Array.isArray(value) ? value : [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {participantList?.length ? (
            participantList.map((item, index) => (
              <Text key={index}>{item?.employee?.fullName || "-"}</Text>
            ))
          ) : (
            <Text>Chưa có nhân viên sale</Text>
          )}
        </Flex>
      );
    }
    case "stepCommission": {
      const stepCommission = Array.isArray(value) ? value : [];
      console.log({stepCommission})
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {stepCommission?.length ? (
            stepCommission.map((item, index) => (
              <Text
                key={index}
              >{`Đợt ${item?.period || 0} - ${item?.month && item?.year ? `${item?.month}/${item?.year}` :  formatMonthDb(item?.createdAt)} (${item?.calculateCommissionRate || 0}%)`}</Text>
            ))
          ) : (
            <Text>Chưa có đợt đối chiếu</Text>
          )}
        </Flex>
      );
    }
    case "inputLate":
      return (
        <Flex
          w={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={1}
        >
          {value && <Image src={iconCheckRed} w={"16px"} height={"16px"} />}
        </Flex>
      );
    case "rate":
      return <Text>{value}%</Text>;
    case "isCollaborator":
      const collaborator = !value ? "Người bán chính" : "CTV";
      return <Text>{collaborator}</Text>;
    case "incomePrice":
      return <Text>{formatPriceUS(value)}</Text>;
    case "platformIncomePrice":
      return <Text>{formatPriceUS(value)}</Text>;
    case "salesCommissionPrice":
      return <Text>{formatPriceUS(value)}</Text>;
    case "eliteSalesCommissionPrice":
      return <Text>{formatPriceUS(value)}</Text>;
    case "bankInfo":
      const bankInfo = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {bankInfo?.length &&
            bankInfo?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    case "identificationNumberInfo":
      const identificationNumberInfo = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {identificationNumberInfo?.length &&
            identificationNumberInfo?.map((item, index) => (
              <Text key={index}>{item}</Text>
            ))}
        </Flex>
      );
    case "status":
      let content;
      if (value === "NEW" || value === "EDITING") {
        content = (
          <>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              // p={"6px 27px 5px 28px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit("APPROVED", id)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Duyệt
            </Button>
            <Button
              bg={"var(--color-main)"}
              color={"var(--color-option-employee-hover)"}
              border={"1px solid var(--color-option-employee-hover)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              // p={"6px 19px 5px 19px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit("REJECTED", id)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Ko duyệt
            </Button>
          </>
        );
      } else if (value === "APPROVED") {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconApproved} w={"20px"} />
              <Text color={"var(--color-status-employ)"}>Đã được duyệt</Text>
            </Flex>
            {/* <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              // p={"6px 27px 5px 28px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => revert("APPROVED", id)}
              h={"28px"}
              minH={"28px"}
            >
              <RiResetLeftFill size={"18px"} />
            </Button> */}
          </Flex>
        );
      } else if (value === "REFUND") {
        content = (
          <>
            <Image src={iconApproved} />
            <Text
              color={"var(--color-status-employ)"}
              w={"max-content"}
              minW={"max-content"}
              display={"block"}
            >
              Đã hoàn trả
            </Text>
          </>
        );
      } else {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconRejected} w={"20px"} />
              <Text color={"var(--text-red-employee)"}>
                Không được phê duyệt
              </Text>
            </Flex>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              // p={"6px 27px 5px 28px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => revert("REJECTED", id)}
              h={"28px"}
              minH={"28px"}
            >
              <RiResetLeftFill size={"18px"} />
            </Button>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"max-content"}>
          {content}
        </Flex>
      );
    case "reviewer":
      return (
        <Box textAlign={"end"}>
          <Text
            fontSize={"14px"}
            lineHeight={"19.6px"}
            fontWeight={"500"}
            color={"var(--color-info-employee)"}
          >
            {value.name}
          </Text>
          <Text
            fontSize={"12px"}
            lineHeight={"16.8px"}
            fontWeight={"400"}
            color={"var(--color-label-employee)"}
          >
            {value.jobTitle}
          </Text>
        </Box>
      );
    case "calculateServiceFees":
      return (
        <Flex gap={"8px"} w={"max-content"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() => handleNavigateCaculatePage(id)}
            h={"28px"}
            minH={"28px"}
            w={"200px"}
          >
            Bắt đầu quy trình tính phí dịch vụ
          </Button>
        </Flex>
      );

    default:
      return <Text>{value}</Text>;
  }
};
